(ns manatee.info.subs
  "Info. view database subscriptions."
  (:require [manatee.app-db :as app-db]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::client-version
 (fn client-version
   [db _]
   (app-db/client-version db)))

(rf/reg-sub
 ::server-version
 (fn server-version
   [db _]
   (app-db/server-version db)))
